import { render } from "./Exchange.vue?vue&type=template&id=7c3855c1"
import script from "./Exchange.vue?vue&type=script&lang=js"
export * from "./Exchange.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\lm-pgac\\PGAC-source\\pgac-600090-ob-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__